import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  RegisterCompanyStepFormSchema,
  RegisterCompanyStepFormMutation,
} from './RegisterCompanyStepForm.types';
import { getRegisterCompanyStepSchema } from './RegisterCompanyStepForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { REGISTER_SIGN_UP_QUERY_KEY, REMOVE_LOGO_ENT_QUERY_KEY, UPLOAD_LOGO_ENT_QUERY_KEY, queryRemoveLogo, queryUploadLogo, registerCompagnyQuery } from './RegisterCompanyStepForm.query';
import { Controller } from 'react-hook-form';
import { RegisterCompanyStepFormData } from './RegisterCompanyStepForm.data';
import Input from '../../../../../commons/Input/Input';
import { useAddressAutocomplete } from '../../../../../../hooks/fetchers/useAddressAutocomplete/useAddressAutocomplete';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import SearchInput from '../../../../../commons/SearchInput/SearchInput';
import { AddressSuggestion } from '../../../../../../types/models/address/address.types';
import departements from '../../../../../../assets/json/departements-region.json';
import Button from '../../../../../designSystem/Button/Button';
import { ButtonColor, ButtonSize } from '../../../../../designSystem/Button/Button.types';
import { useDispatch } from 'react-redux';
import { setProfile } from '../../../../../../store/authentication/authenticationActions/authenticationActions';
import { useCookies } from 'react-cookie';
import { UserENT } from '../../../../../../types/models/user/user.types';
import { api } from '../../../../../../utils/api/api';
import moment from 'moment';
import Select from '../../../../../commons/Select/Select';
import { usePlansENT } from '../../../../../../hooks/fetchers/usePlansENT/usePlansENT';
import { useUserInfos } from '../../../../../../hooks/fetchers/useUserInfos/useUserInfos';
import {
  Company,
  CompanyLegalStatutes,
} from '../../../../../../types/models/company/company.types';
import RegisterStepButton from '../../../../../commons/RegisterStepButton/RegisterStepButton';
import PlaceholderImage from "../../../../../../assets/images/placeholder2.jpg"
import { useDropzone } from 'react-dropzone';
import { BaseResponse } from '../../../../../../types/api/api.types';
import { useCurrentLogo } from '../../../../../../hooks/fetchers/useCurrentLogo/useCurrentLogo';

export default () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [, setCookie, removeCookie] = useCookies(['token']);

  const { acceptedFiles, open } = useDropzone({
    multiple: false,
    accept: {
      'image/*': ['.png', '.jpg', '.jpeg'],
      // 'application/pdf': ['.pdf'],
    },
  });

  const [searchInputValue, setSearchInputValue] = useState<string>('');
  
  const [displayedImage, setDisplayedImage] = useState<string>();

  const { data: plansENT } = usePlansENT();

  const { data: userInfos } = useUserInfos();

  const { data: userLogo } = useCurrentLogo();
;
  const { data: addressSuggestions } = useAddressAutocomplete(searchInputValue);

  const formProps = useForm<RegisterCompanyStepFormSchema>({
    resolver: yupResolver(getRegisterCompanyStepSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    ...(userInfos && {
      defaultValues: {
        name: userInfos.name,
        address: userInfos.address,
        city: userInfos.city,
        postalCode: userInfos.postalCode,
        department: userInfos.department,
        region: userInfos.region,
        siret: userInfos.siret,
        firstName: userInfos.firstName,
        lastName: userInfos.lastName,
        email: userInfos.email,
        phone: userInfos.phone,
        function: userInfos.function,
        // firstName_owner: userInfos.firstName_owner,
        // lastName_owner: userInfos.lastName_owner,
        email_owner: userInfos.email_owner,
        phone_owner: userInfos.phone_owner,
        // function_owner: userInfos.function_owner,
      },
    }),
  });

  useEffect(() => {
    if (userInfos) {
      setValue('email', userInfos.email, { shouldValidate: true })
    }
  }, [userInfos])

  useEffect(() => {
    if (userLogo) {
      // @ts-ignore
      setDisplayedImage(URL.createObjectURL(userLogo))
      console.log('userLogo', userLogo)
    }
  }, [userLogo])

  const {
    handleSubmit,
    control,
    // getValues,
    setValue,
    formState: { isValid, errors },
  } = formProps;

  const { mutate } = useMutation<
    Awaited<ReturnType<RegisterCompanyStepFormMutation>>,
    Error,
    RegisterCompanyStepFormSchema
  >((data) => registerCompagnyQuery(data), {
    mutationKey: REGISTER_SIGN_UP_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: async ({ user, accessToken }) => {
      api.setHeader('authorization', `Bearer ${accessToken}`);
      removeCookie('token', { path: '/' });
      setCookie('token', accessToken, { expires: moment().add(60, 'minutes').toDate(), path: '/' });
      setProfile(user)(dispatch);
    },
    onError: async (error) => {
      alert(error.message);
    },
  });

  const { mutate: uploadLogo } = useMutation<Awaited<BaseResponse>, Error, FormData>(
    (data) => queryUploadLogo(data),
    {
      mutationKey: UPLOAD_LOGO_ENT_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: async () => {
        setDisplayedImage(URL.createObjectURL(acceptedFiles[0]))
      },
      onError: async (error) => {
        alert(error.message);
      },
    }
  );

  const { mutate: removeLogo } = useMutation<Awaited<BaseResponse>, Error>(
    () => queryRemoveLogo(),
    {
      mutationKey: REMOVE_LOGO_ENT_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: async () => {
        setDisplayedImage(undefined)
      },
      onError: async (error) => {
        alert(error.message);
      },
    }
  );

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      const formData = new FormData();
      for (const file of acceptedFiles) {
        formData.append('image', file);
      }
      uploadLogo(formData);
    }
  }, [acceptedFiles])

  const onAddressChange = (
    e: ChangeEvent<HTMLInputElement>,
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
  ) => {
    const value = e.target.value;
    onChange(e);
    setSearchInputValue(value);
  };

  const handleSelectedSuggestion = (suggestion: AddressSuggestion) => {
    setSearchInputValue('');
    setValue('address', suggestion.address);
    setValue('city', suggestion.city);
    setValue('postalCode', suggestion.postalCode);
    setValue('department', suggestion.department);
    setValue(
      'region',
      departements.find((res) => res.num_dep.toString() == suggestion.department_code)
        ?.region_name || ''
    );
    if (suggestion.coordinates) {
      setValue('latitude', suggestion.coordinates.latitude)
      setValue('longitude', suggestion.coordinates.longitude)
    }
  };

  // const handleReuseSameInfos = (
  //   infos: Pick<User, 'firstName' | 'lastName' | 'email' | 'phone' | 'function'>
  // ) => {
  //   // setValue('firstName_owner', infos.firstName, { shouldValidate: true });
  //   // setValue('lastName_owner', infos.lastName, { shouldValidate: true });
  //   setValue('email_owner', infos.email, { shouldValidate: true });
  //   setValue('phone_owner', infos.phone, { shouldValidate: true });
  //   // setValue('function_owner', infos.function, { shouldValidate: true });
  // };

  const onSubmit = handleSubmit((data) => mutate(data));

  const updatedFormData = useMemo(
    () =>
      RegisterCompanyStepFormData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            // case 'useSameInfos':
            //   return {
            //     ...item,
            //     onChange: (e: ChangeEvent<HTMLInputElement>) => {
            //       const isChecked = Boolean(e.target.checked);
            //       if (isChecked) {
            //         handleReuseSameInfos({
            //           firstName: getValues('firstName'),
            //           lastName: getValues('lastName'),
            //           email: getValues('email'),
            //           phone: getValues('phone'),
            //           function: getValues('function'),
            //         });
            //       }
            //     },
            //   };
            case 'plan':
              if (plansENT && userInfos && userInfos.id_step > 2) {
                return {
                  ...item,
                  disabled: true,
                  defaultValue: {
                    value: (userInfos as UserENT).id_plan,
                    label: plansENT?.find(({ id }) => id === (userInfos as UserENT).id_plan)?.label,
                  },
                };
              } else {
                return {
                  ...item,
                  options: plansENT?.map(({ id, label }) => ({
                    value: id,
                    label,
                  })),
                };
              }
            case 'legalStatutes':
              return {
                ...item,
                ...(userInfos &&
                  (userInfos as Company).legalStatutes && {
                    disabled: true,
                    defaultValue: {
                      value: (userInfos as Company).legalStatutes,
                      label:
                        CompanyLegalStatutes[
                          (userInfos as Company).legalStatutes as keyof typeof CompanyLegalStatutes
                        ],
                    },
                  }),
              };
            case 'name':
              return {
                ...item,
                ...(userInfos &&
                  userInfos.id_step > 2 && {
                    disabled: true,
                  }),
              };
            default:
              return item;
          }
        })
      ),
    [plansENT, userInfos]
  );

  return (
    <form className="form">
      <div className="form__row" 
        style={{ 
          marginBottom: 'var(--spacing-sToM)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        <div className='register__company-logo-box'>
          <img 
            className='register__company-logo-img' 
            src={displayedImage || PlaceholderImage} 
          />
        </div>
        {displayedImage &&
          <button 
            className='register__company-logo-button register__company-logo-button-remove'
            onClick={(e) => {
              e.preventDefault()
              removeLogo()
            }}
          >
            Supprimer
          </button>
        }
        <button 
          className='register__company-logo-button'
          onClick={(e) => {
            e.preventDefault()
            open()
          }}
        >
          Importer un logo
        </button>
      </div>
      {updatedFormData.map((row, rowIndex) => (
        <div key={rowIndex} className="form__row">
          {row.map(({ name, placeholder, label, type, options, ...props }, inputIndex) => (
            <Controller
              key={inputIndex}
              name={name}
              render={({ field: { onChange, value, ...rest } }) =>
                name === 'address' ? (
                  // @ts-ignore
                  <SearchInput
                    suggestions={addressSuggestions}
                    placeholder={placeholder || ''}
                    type={type}
                    onChange={(e) => onAddressChange(e, onChange)}
                    error={errors[name]?.message as string}
                    // @ts-ignore
                    value={value}
                    {...{ label, handleSelectedSuggestion, name }}
                    {...props}
                  />
                ) : type !== 'select' ? (
                  // @ts-ignore
                  <Input
                    placeholder={placeholder || ''}
                    type={type}
                    disabled={Boolean(
                      ['department', 'region', 'city', 'postalCode'].includes(name)
                    )}
                    error={errors[name]?.message as string}
                    // @ts-ignore
                    value={value}
                    {...{ onChange, label, name }}
                    {...props}
                  />
                ) : (
                  <Select
                    placeholder={placeholder || ''}
                    error={errors[name]?.message as string}
                    {...{ label, options, ...rest }}
                    {...props}
                    // @ts-ignore
                    onChange={({ value }: SelectOption) => {
                      onChange(value);
                    }}
                  />
                )
              }
              {...{ control }}
            />
          ))}
        </div>
      ))}
      <RegisterStepButton isCompany />
      <Button
        style={{ alignSelf: 'unset' }}
        onClick={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        size={ButtonSize.Large}
        disabled={!isValid}
        color={ButtonColor.Secondary}>
        Valider
      </Button>
    </form>
  );
};
